import { render, staticRenderFns } from "./AppTermOfService.vue?vue&type=template&id=967d2b7e&scoped=true"
import script from "./AppTermOfService.vue?vue&type=script&lang=js"
export * from "./AppTermOfService.vue?vue&type=script&lang=js"
import style0 from "./AppTermOfService.vue?vue&type=style&index=0&id=967d2b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967d2b7e",
  null
  
)

export default component.exports